module.exports = __webpack_public_path__ + "components/flag/static/square/mg-4a8cf9be1b69d8ca98148f091129eee3.svg";